import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'customDate'
})
export class CustomDatePipe extends DatePipe implements PipeTransform {

    transform(value: Date, short?: string, showWeekDay?: string) {
        let customDate;
        const date = new Date(value);

        if (this.isToday(date)) {
            customDate = `Today`;
        } else if (this.isYesterday(date)) {
            customDate = `Yesterday`;
        } else {
            if (short) {
                if (showWeekDay) {
                    // Wed 15 Jan
                    customDate = super.transform(date, "EEE dd MMM y");
                } else {
                    customDate = super.transform(date, "dd MMM y");
                }
            } else {
                if (showWeekDay) {
                    // Wednesday 15 January 2020
                    customDate = super.transform(date, "EEEE d MMMM y");
                } else {
                    customDate = super.transform(date, "d MMMM y");
                }
            }
        }
        return customDate;
    }

    isToday(someDate) {
        const today = new Date();
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear();
    }

    isYesterday(someDate) {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return someDate.getDate() === yesterday.getDate() &&
            someDate.getMonth() === yesterday.getMonth() &&
            someDate.getFullYear() === yesterday.getFullYear();
    }
}
